import styled from '@emotion/styled';

const CardWrapper = styled.article`
  flex-shrink: 0;
  border: ${({ theme }) => `1px solid ${theme.colors.neutral.grey40}`};
  border-radius: ${({ theme }) => theme.radius.md};
  box-shadow: ${({ theme }) => theme.elevation.medium};
  color: ${({ theme }) => theme.colors.neutral.grey160};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
`;

export { CardWrapper };
